<dx-tree-list #codeTreeList [height]="codeTreeListHeight"
              [dataSource]="dataSourceDocumentCodes"
              keyExpr="DocumentCodeId"
              parentIdExpr="ParentDocumentCodeId"
              [showRowLines]="true"
              [showBorders]="true"
              [columnAutoWidth]="true"
              autoExpandAll="false"
              (onCellClick)="onCellClick($event)"
              [selectedRowKeys]="selectedCodes"
              [disabled]="isReadOnly">
  <dxo-selection mode="multiple" [recursive]="false"></dxo-selection>
  <dxi-column dataField="DocumentCodeName" [caption]="this.languageService.LNG('Label.Name')"></dxi-column>
  <dxi-column dataField="DocumentCodeDescription" [caption]="this.languageService.LNG('Label.Description')"></dxi-column>
</dx-tree-list>
